export const SALONHEADER_COMPONENT_MODAL_ID = 'SALONHEADER_COMPONENT_MODAL';
export const ADD_NEW_MODULE_MODAL_ID = 'ADD_NEW_MODULE_MODAL_ID';
export const VANITY_URL_MODAL_ID = 'VANITY_URL_MODAL_ID';
export const LOCATION_LOGO_MODAL_ID = 'LOCATION_LOGO_MODAL_ID';
export const SHARE_MODAL_ID = 'SHARE_MODAL_ID';
export const SHARE_LINK_MODAL_ID = 'SHARE_LINK_MODAL_ID';
export const SHARE_SALON_ID = 'SHARE_SALON_ID';
